var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "00-Elements-/-Icons-/-arrowhead-left-icon",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4078,15.6454 C11.7167,16.078 12.3155,16.1217 12.6778,15.7383 L12.7528,15.6589 C13.0445,15.3501 13.0826,14.8633 12.8428,14.5079 L9.13271,9.97184 L12.8427,5.49205998 C13.0825,5.13669998 13.0445,4.64989997 12.7527,4.34109997 L12.6777,4.26167997 C12.3155,3.87824997 11.7167,3.92204997 11.4077,4.35457997 L7.17077999,9.43303 C6.94306998,9.7518 6.94306998,10.1919 7.17077999,10.5106 L11.4078,15.6454 Z",
  id: "arrowhead-left-icon"
}));

function SvgArrowheadLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowheadLeftIcon);
export default __webpack_public_path__ + "static/media/arrowhead-left-icon.795435c7.svg";
export { ForwardRef as ReactComponent };